import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import styles from "./Workflow.module.scss";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

interface Props {
  open: boolean;
}

const SaveSuccessDialog: React.FC<Props> = ({ open }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Dialog
      className={styles.saveSuccessDialog}
      open={open}
      fullWidth
      maxWidth="md"
    >
      <DialogTitle>{t("yourProgressWassSuccessfullySaved")}</DialogTitle>
      <DialogContent>
        <CheckCircleIcon />
        <p>{t("youCanContinueWithThisWorkflowInTheFuture")}</p>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={() => navigate("/")}>
          {t("backToHome")}
        </Button>
        <Button variant="text" onClick={() => navigate("/myinbox")}>
          {t("goToMyPublications")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SaveSuccessDialog;
